import { z } from 'zod/v4';
export var Brand;
(function (Brand) {
    Brand["AUDI"] = "A";
    Brand["VW"] = "V";
    Brand["SKODA"] = "C";
    Brand["BENTLEY"] = "E";
    Brand["LAMBORGHINI"] = "L";
    Brand["MAN_TRUCKS_BUS"] = "M";
    Brand["VW_NUTZFAHRZEUGE"] = "N";
    Brand["PORSCHE"] = "P";
    Brand["SEAT"] = "S";
})(Brand || (Brand = {}));
export const BrandSchema = z.enum(Object.values(Brand));
//# sourceMappingURL=brand.js.map